import type { Mission } from '../missions.ts'

export const navy: Mission = {
  id: "navy",
  name: "U.S. Navy",
  short: "USN",
  kind: "subagency",
  parent: "dod",
  url: "https://www.navy.mil/",
  established: 1775,
  palette: {
    primary: "#0076a9",
    secondary: "#022a3a",
    accent: "#e8b00f",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://etoolbox.cnrc.navy.mil/assets/documents/BrandGuidelines_Print.pdf",
  },
  motif: "anchor",
  mission: {
    text: "The United States is a maritime nation, and the U.S. Navy protects America at sea.",
    url: "https://www.navy.mil/About/Mission/",
  },
  fact: {
    text: "On October 13, 1775, the Continental Congress authorized two armed vessels, the act the Navy marks as its birthday.",
    url: "https://www.history.navy.mil/browse-by-topic/commemorations-toolkits/navy-birthday/navy-birthday-background.html",
  },
  seal: {
    file: "public/seals/navy.svg",
    source: "https://commons.wikimedia.org/wiki/File:Emblem_of_the_United_States_Navy.svg",
  },
  logo: {
    file: "public/logos/navy.svg",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Navy.svg",
  },
  identifier: {
    about: "https://www.navy.mil/About/",
    accessibility: "https://dodcio.defense.gov/DoDSection508.aspx",
    foia: "https://www.secnav.navy.mil/foia/Pages/default.aspx",
    noFear: "https://prhome.defense.gov/NoFear",
    oig: "https://www.secnav.navy.mil/ig/Pages/Home.aspx",
    performance: "https://www.performance.gov/agencies/dod",
    privacy: "https://www.navy.mil/Privacy-Policy",
  },
  media: {
    photos: [
      {
        file: "/media/navy-blue-angels.jpg",
        small: "/media/navy-blue-angels-sm.jpg",
        alt: "Four blue and gold Blue Angels F/A-18 Hornets fly in tight echelon formation against a bright cloudy sky.",
        title: "The Blue Angels at the Kaneohe Bay Airshow, Hawaii, September 30, 2012",
        creator: "Mass Communication Specialist 2nd Class Daniel Barker, U.S. Navy",
        source: "https://commons.wikimedia.org/wiki/File:Flickr_-_Official_U.S._Navy_Imagery_-_The_Blue_Angels_fly_in_formation..jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/navy-uss-constitution.jpg",
        small: "/media/navy-uss-constitution-sm.jpg",
        alt: "USS Constitution, a three-masted wooden frigate, under sail in Boston Harbor with sailboats in the distance.",
        title: "USS Constitution sets sail in Boston Harbor, August 19, 2012",
        creator: "Mass Communication Specialist Seaman Michael Achterling, U.S. Navy",
        source: "https://commons.wikimedia.org/wiki/File:Flickr_-_Official_U.S._Navy_Imagery_-_USS_Constitution_sets_sail..jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
